// extracted by mini-css-extract-plugin
export default {"hasBackground":"OrgsPageTemplateV3_hasBackground__6i5ST","placeHolderShimmer":"OrgsPageTemplateV3_placeHolderShimmer__T0HEF"};